module.exports = __webpack_public_path__ + "images/sg-email-placeholder.png";